module.exports = __webpack_public_path__ + "7b8c04c484f7c3bac657e8bceb5fbc31.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/6_column_xlarge_x1/public/games/sm_image_3.png
// module id = 492
// module chunks = 0